import React from "react";

// Rank movement is real data, not decoration: `rank` and `previousRank` are
// both serialized by the API's publicPlayer. A player with no previous rank
// (new to the register) shows an em dash rather than a fake climb.
const RankMovement = ({ rank, previousRank, showLabel = false, className = "" }) => {
  const delta =
    typeof rank === "number" && typeof previousRank === "number"
      ? previousRank - rank
      : 0;

  if (!delta) {
    return (
      <span className={`text-sm text-muted ${className}`} title="No change">
        —
      </span>
    );
  }

  const up = delta > 0;
  return (
    <span
      className={`inline-flex items-center gap-1 text-sm font-semibold ${
        up ? "text-success" : "text-danger"
      } ${className}`}
      title={`${up ? "Up" : "Down"} ${Math.abs(delta)} ${
        Math.abs(delta) === 1 ? "position" : "positions"
      }`}
    >
      <span aria-hidden="true">{up ? "↑" : "↓"}</span>
      <span className="tabular">{Math.abs(delta)}</span>
      {showLabel && (
        <span className="font-medium">
          {Math.abs(delta) === 1 ? "position" : "positions"}
        </span>
      )}
    </span>
  );
};

export default RankMovement;
